import { lazy } from 'react';
import Loadable from 'components/Loadable';

// Lazy loaded auth pages
const LoginPage = Loadable(lazy(() => import('pages/auth/Login')));
const RegisterPage = Loadable(lazy(() => import('pages/auth/Register')));
const PrivacyPolicy = Loadable(lazy(() => import('pages/auth/PrivacyPolicy')));
// CORRECT
const AuthCallback = Loadable(lazy(() => import('pages/auth/AuthCallback')));

// Auth Routes
const LoginRoutes = {
  path: '/',
  children: [
    {
      path: 'login',
      element: <LoginPage />
    },
    {
      path: 'privacy-policy',
      element: <PrivacyPolicy />
    },
    {
      path: 'register',
      element: <RegisterPage />
    },
    // ✅ 2. Add the new route here
    {
      path: 'auth/callback',
      element: <AuthCallback />
    }
  ]
};

export default LoginRoutes;
